export default {
    getHeaderFields: state => state.headerFields,
    getSearchFields: state => state.searchFields,
    getSupervisorHeaderFields: state => state.supervisorHeaderFields,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getSupervisorActions: state => state.supervisorActions,
    getRowActions: state => state.rowActions,
    getSupervisorRowActions: state => state.superVisorRowActions,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,
    isSupervisorGridOpen: state => state.supervisorGridIsOpen,
    getDataTableOptions: state => state.dataTableOptions,
}
